module.exports = __webpack_public_path__ + "img/mhhc_logo_bottom.eab16850.png";